module.exports = __webpack_public_path__ + "media/icons/favourite-yes@3x-794a158d.svg";